"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var defineDimensionsBasedOnSize = function defineDimensionsBasedOnSize(size) {
  if (!size) {
    return 80;
  }

  return size === 's' ? 80 : 130;
};

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    productImage: {
      width: function width(_ref2) {
        var size = _ref2.size;
        return defineDimensionsBasedOnSize(size);
      },
      height: function height(_ref3) {
        var size = _ref3.size;
        return defineDimensionsBasedOnSize(size);
      },
      borderRadius: 4,
      color: palette.grey.superLight,
      backgroundImage: function backgroundImage(_ref4) {
        var image = _ref4.image;
        return "url(".concat(image, ")");
      },
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }
  };
});

var ProductImage = function ProductImage(_ref5) {
  var className = _ref5.className,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["className"]);
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: (0, _classnames["default"])(classes.productImage, className)
  });
};

ProductImage.propTypes = {
  image: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].oneOf(['s', 'm']),
  className: _propTypes["default"].string
};
ProductImage.defaultProps = {
  size: 's'
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductImage);

exports["default"] = _default;